import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewPermissions = () => { 
    return useQuery({ 
        queryKey: ['viewpermissions'], 
        queryFn: async () => { 
            const res = await api.get('/permissions/show', {
            }); 
            return res.data; 
        }
     });
};  